import { COLORS } from '@/constants';
import styled from 'styled-components';
import { CardFooter } from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/styled';

export const SnippetCard = styled.div`
  background: ${COLORS['primary/910']};
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.2);
  min-width: 0;
`;

export const SnippetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
`;

export const SnippetTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS['neutral/500']};
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const SnippetActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SnippetCopyBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS['neutral/300']};
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  cursor: pointer;
  font-family: inherit;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    color: ${COLORS.white};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS['primary/500']};
    outline-offset: 2px;
  }
`;

export const SnippetPre = styled.pre`
  margin: 0;
  padding: 20px;
  overflow-x: auto;
  max-width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.7;
  color: ${COLORS['neutral/300']};
  font-family: 'Fira Code', 'Cascadia Code', monospace;
  white-space: pre-wrap;
  word-break: break-all;
`;

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const SnippetActionBar = styled(ActionBar)`
  margin-top: 12px;
`;

export const SrOnly = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const DocsStepList = styled.ol`
  list-style: none;
  padding: 20px 24px 16px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DocsStepItem = styled.li`
  display: flex;
  gap: 14px;
`;

export const DocsStepNumber = styled.span`
  min-width: 26px;
  height: 26px;
  background: ${COLORS['primary/600']};
  color: ${COLORS.white};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 1px;
`;

export const DocsStepBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DocsProse = styled.p`
  font-size: 14px;
  color: ${COLORS['neutral/600']};
  line-height: 1.6;
  margin: 0;
`;

export const HowItWorksFooter = styled(CardFooter)`
  cursor: default;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
`;

export const HowItWorksBody = styled.div`
  padding-top: 12px;
`;

export const CalloutWrapper = styled.div`
  margin-top: 8px;
`;
